
import React from 'react';
import './policies.css';

function DisputeResolutionPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Dispute & Resolution Policy</h1>

        <p className="last-updated">
          Last Updated: June 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            At <strong>Mr White</strong>, we strive to ensure that our customers
            have a positive experience. However, we understand that disputes may
            occasionally arise. This Dispute & Resolution Policy outlines the
            procedures for addressing and resolving disputes fairly and
            effectively.
          </p>
        </div>

        <div className="policy-section">
          <h2>Definition of Dispute</h2>

          <p>
            A dispute is defined as a disagreement between a customer and
            Mr White regarding a transaction or service provided through our
            platform.
          </p>

          <p>
            Common reasons for disputes may include:
          </p>

          <ul className="policy-list">
            <li>Wrong product or item received.</li>
            <li>Product or service not as described.</li>
            <li>Damaged items or broken packaging/seals.</li>
            <li>Missing parts, accessories, or garments.</li>
            <li>Incorrect merchant or brand information.</li>
            <li>Defective or non-functional products.</li>
            <li>Invoice or documentation-related concerns.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>1. Contacting Customer Support</h2>

          <p>
            If you experience any of the issues listed above, please contact
            our customer support team within <strong>2 days</strong> of
            receiving your order.
          </p>

          <p>
            Email:{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            Phone:{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Information Required</h2>

          <p>
            When reporting a dispute, please provide the following details:
          </p>

          <ul className="policy-list">
            <li>Order number.</li>
            <li>
              Detailed description of the issue.
            </li>
            <li>
              Photographs or supporting evidence, if applicable.
            </li>
            <li>
              Any previous communication regarding the issue.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Investigation</h2>

          <p>
            Upon receiving your dispute report, our team will conduct a prompt
            and thorough investigation. We may contact you to request
            additional information or clarification where necessary.
          </p>
        </div>

        <div className="policy-section">
          <h2>4. Resolution Options</h2>

          <p>
            Once our investigation is complete, we may offer one of the
            following resolutions:
          </p>

          <ul className="policy-list">
            <li>Replacement of the product or item.</li>
            <li>Refund of the purchase amount.</li>
            <li>Store credit for future purchases or services.</li>
          </ul>

          <p>
            We aim to resolve disputes within
            <strong> 14 business days </strong>
            from the date we receive your complaint.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Final Decision</h2>

          <p>
            The final decision regarding the resolution of any dispute will
            rest with Mr White based on the findings of our investigation.
            We are committed to ensuring fair and reasonable outcomes for all
            parties involved.
          </p>
        </div>

        <div className="policy-section">
          <h2>Contact Us</h2>

          <p>
            If you have any questions, concerns, or need to report a dispute,
            please contact our customer service team:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default DisputeResolutionPolicy;

